import { Input } from "@mantine/core";
import styled from "styled-components";

export const SignatureDisplay = styled.div`
    border: 2px dashed #ccc;
    padding: 15px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Dancing Script', cursive;
    font-size: 28px;
    height: 200px;
    font-weight: 400;
    color: #000;
    line-height: 1.2;
    letter-spacing: 0;
    background-color: white;
`;

export const NameInput = styled(Input.Wrapper)`
    label {
        font-family: 'Manrope', sans-serif;
        font-weight: 600;
        margin-bottom: 8px;
        font-size: 14px;
    }
    input {
        font-family: 'Manrope', sans-serif;
        border-radius: 8px;
        &:disabled {
            background-color: #f1f1f1;
            color: #888;
            cursor: not-allowed;
        }
    }
`;

export const SignatureCanvasWrapper = styled.div`
  border: 1px dashed #ccc;
  z-index: 1;
  border-radius: 8px;
  touch-action: none;
  width: 100%;
  height: 250px;
  position: relative;
`;

export const SignatureHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0 4px 0;
`;

export const SignatureLabel = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Manrope';
  font-size: 14px;
  color: #292929;
  font-weight: 500;
  gap: 2px;
  padding-left: 10px;
  padding-right: 5px;
`;

export const SignatureLine = styled.div`
  width: 90%;
  height: 1px;
  background: #3A3A3A;
  border-radius: 1px;
`;
